const fonts = {
  museoSans: "'Museo Sans', sans-serif",
  museoSansRounded: "'Museo Sans', sans-serif",
}

export default fonts
